module.exports = __webpack_public_path__ + "img/attention-icon.56c4f9cd.svg";